import {
  Box,
  Divider,
  List,
  SwipeableDrawer,
  Typography,
  alpha,
  useTheme,
} from "@mui/material";
import driversidebarCover from "../../../../media/images/driversidebarCover.svg";

import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../hooks/useRedux";
import { setOpenDriverSidebar } from "../../../../redux/features/settingSlice";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../redux/features/snackbarSlice";
import {
  setDialogStatus,
  setDialogTitle,
  setOpenDialog,
} from "../../../../redux/features/dialogSlice";
import CustomListItem from "./components/ListItem";
import Money_Report from "../../../../media/images/icons/Money_Report.png";
import BigCar_3d from "../../../../media/images/icons/bigcar-3d.png";
import ProfileImage from "../../../../media/images/profileImage.svg";
import InfoAuth from "../../../../media/images/icons/auth-info.svg";
import { Link, useLocation } from "react-router-dom";
import ThemeToggle from "../../../components/ThemeToggle";
import CarTagView from "../../../components/CarTag";
import ArrowLeftCircle from "../../../../media/images/icons/arrow-left-circle";
import EmptyWallet from "../../../../media/images/icons/empty-wallet";
import { blueGrey, grey } from "@mui/material/colors";
import CloseSquerSVG from "../../../../media/images/icons/close-squer";
import useLogout from "../../../../hooks/useLogout";
import NotifsIcon from "../../../../media/images/icons/notification-bing";
import BuildingSingleSVG from "../../../../media/images/icons/building-single";
import GuidSVG from "../../../../media/images/icons/guid-icon";
import InfoCircle from "../../../../media/images/icons/info-circle";
import LogoutSVG from "../../../../media/images/icons/login-newsvg";
// import AuthLink from "./components/AuthLink";
import PromotReportSVG from "../../../../media/images/icons/promot-report";
import PenSVG from "../../../../media/images/icons/pen-square 1";
import SmsEditSVG from "../../../../media/images/icons/sms-edit";
import UserOctagone from "../../../../media/images/icons/user-octagone";
import AuthorizationDriverLabel from "../../../components/AuthorizationDriverLabel";
import RefreshSVG from "../../../../media/images/icons/refresh";
import { triggerServiceWorkerUpdate } from "../../../../utils/serviceWorkerUpdate";

export default function DriverSidebar() {
  const driverSidebar = useAppSelector((state) => state.settings.driverSidebar);
  const themeMode = useAppSelector((state) => state.settings.themeMode);

  const dispatch = useAppDispatch();

  const { pathname } = useLocation();

  const { fullName, mobileNr, vehicleInfo } = useAppSelector(
    (state) => state.user
  );
  const theme = useTheme();

  const [handleLogout] = useLogout();
  const [isUpdating, setIsUpdating] = useState(false);

  const handleUpdateApp = async () => {
    if (isUpdating) return;
    setIsUpdating(true);
    try {
      const result = await triggerServiceWorkerUpdate();
      if (!result.reloaded && result.message) {
        if (result.success) {
          dispatch(setOpenDriverSidebar(false));
          dispatch(setDialogStatus("success"));
          dispatch(setDialogTitle(result.message));
          dispatch(setOpenDialog(true));
          setTimeout(() => dispatch(setOpenDialog(false)), 3000);
        } else {
          dispatch(setSnackbarErrorStatus(400));
          dispatch(setSnackbarDescription(result.message));
          dispatch(setOpenSnackbar(true));
        }
      }
    } finally {
      setIsUpdating(false);
    }
  };

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      dispatch(setOpenDriverSidebar(false));
    };

  return (
    <div className="sidebarDrawer">
      <style>
        {`
        // .MuiDrawer-root {
        // position: ${
          driverSidebar ? "fixed !IMPORTANT" : "static !IMPORTANT"
        };
        // }
     .sidebarDrawer {
  max-width: 450px;
  z-index:3000;
  // z-index:${driverSidebar ? "2800" : ""};
  margin-right: auto;
  margin-left: auto;
  /* overflow-x: visible; */
  overflow-y: hidden;
}
`}
      </style>
      <SwipeableDrawer
        className="sidebarDrawer"
        dir="rtl"
        sx={{
          "& .MuiPaper-root": {
            width: 270,

            position: "absolute",
            bgcolor: themeMode === "light" ? blueGrey[50] : grey[800],
            right: "0px",
            top: "0px",
            bottom: "0px",
            height: "auto",
            // borderRadius: "15px",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            paddingBottom: "16px",
          },
        }}
        anchor="right"
        transitionDuration={200}
        open={driverSidebar}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        disableSwipeToOpen={true}
      >
        <Box
          sx={{
            backgroundImage: `
            url(${driversidebarCover})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundColor: "#0D4884",
            display: "flex",
            flexDirection: "column",
            justifyContent: "end",
            padding: "8px 8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box onClick={() => dispatch(setOpenDriverSidebar(false))}>
              <CloseSquerSVG size={44} color={theme.palette.error.main} />
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "bgColor.grey100",
                borderRadius: "4px",
                padding: "4px",
                gap: "8px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "15px",
                  fontWeight: "600",
                }}
              >
                {themeMode === "light" ? "حالت تاریک" : "حالت روشن"}
              </Typography>
              <ThemeToggle />
            </Box>
          </Box>
          <Box
            sx={{
              marginTop: "8px",
              backgroundColor: "bgColor.white",
              // border: "1px solid gray",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              borderRadius: "10px",
              padding: "8px",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <img
                  style={{
                    borderRadius: "16px",
                  }}
                  width={40}
                  src={ProfileImage}
                  alt=""
                />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "12px",
                    }}
                  >
                    {fullName}
                  </Typography>
                  <AuthorizationDriverLabel />
                </Box>
              </Box>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                {mobileNr}
              </Typography>
            </Box>
            {/* بنر تکمیل مدارک و پروفایل
            {!isConfirm && <AuthLink />}
            */}

            <Box
              sx={{
                backgroundColor: "bgColor.white",
                width: "100%",
                borderRadius: "8px",
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >
                  {vehicleInfo?.loaderTypeGroup || "-------"}
                </Typography>
                <CarTagView />
              </Box>
              {/* <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "600",
                    fontSize: "14px",
                  }}
                >
                  تاریخ پایان معاینه فنی:
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "600",
                    fontSize: "14px",
                  }}
                >
                  --/--/----
                </Typography>
              </Box> */}
              {/* <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "600",
                    fontSize: "14px",
                  }}
                >
                  تاریخ پایان کارت سلامت:
                </Typography>
                <Typography sx={{ fontWeight: "600", fontSize: "14px" }}>
                  --/--/----{" "}
                </Typography>
              </Box> */}
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              mt: 1,
            }}
          >
            <Link
              to={"/driver/profile"}
              style={{
                padding: "8px 4px",
                backgroundColor: theme.palette.bgColor.white,
                borderRadius: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                // border: "1px solid gray",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "3px",
                }}
              >
                <UserOctagone
                  color={
                    themeMode === "light"
                      ? theme.palette.textColor.main
                      : "#fff"
                  }
                />
                <Typography>مشخصات حساب/ناوگان</Typography>
              </Box>
              <ArrowLeftCircle
                color={
                  themeMode === "light" ? theme.palette.textColor.main : "#fff"
                }
              />
            </Link>
            <Link
              to={"/driver/wallet"}
              style={{
                padding: "8px 4px",
                backgroundColor: theme.palette.bgColor.white,
                borderRadius: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                // border: "1px solid gray",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "3px",
                }}
              >
                <EmptyWallet
                  color={
                    themeMode === "light"
                      ? theme.palette.textColor.main
                      : "#fff"
                  }
                />
                <Typography>کیف پول </Typography>
              </Box>
              <ArrowLeftCircle
                color={
                  themeMode === "light" ? theme.palette.textColor.main : "#fff"
                }
              />
            </Link>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: "8px",
            px: "8px",
            alignItems: "center",
          }}
        >
          <Link
            to={"check-in"}
            style={{
              flex: "1",
              height: 40,
              overflow: "hidden",
              borderRadius: "8px",
              padding: "0px 0px",
              width: "fit-content",
              display: "flex",
              alignItems: "center",
              backgroundColor: theme.palette.primary.main,
              gap: "3px",
            }}
          >
            <img width={40} src={BigCar_3d} alt="" />
            <Typography
              sx={{
                whiteSpace: "nowrap",
                color: "#fff",
                fontSize: "14px",
              }}
            >
              اعلام حضور{" "}
            </Typography>
          </Link>
          <Link
            to={"tender-offer"}
            style={{
              flex: "1",
              height: 40,
              overflow: "hidden",
              borderRadius: "8px",
              padding: "0px 0px",
              width: "fit-content",
              display: "flex",
              alignItems: "center",
              backgroundColor: theme.palette.primary.main,
            }}
          >
            <img height={40} width={40} src={Money_Report} alt="" />
            <Typography
              sx={{
                whiteSpace: "nowrap",
                fontSize: "14px",
                color: "#fff",
              }}
            >
              مناقصات بار
            </Typography>
          </Link>
        </Box>

        <Box
          sx={{
            paddingX: "8px",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              backgroundColor:
                themeMode === "dark" ? alpha("#fff", 0.1) : "#fff",
              // border: "1px solid gray",
              borderRadius: "10px",
              width: "100%",
              maxWidth: 360,
            }}
          >
            <nav
              style={{
                padding: "0px 8px",
              }}
              aria-label="main mailbox folders"
            >
              <List
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                }}
              >
                <CustomListItem
                  path="/driver/ticket"
                  title="ثبت تیکت"
                  icon={
                    <SmsEditSVG
                      size={20}
                      color={
                        pathname === "/driver/ticket"
                          ? "#fff"
                          : theme.palette.textColor.main
                      }
                    />
                  }
                />
                <Divider variant="middle" />
                <CustomListItem
                  path="/driver/bols-histories"
                  title="سوابق بارها"
                  icon={
                    <PromotReportSVG
                      size={20}
                      color={
                        pathname === "/driver/bols-histories"
                          ? "#fff"
                          : theme.palette.textColor.main
                      }
                    />
                  }
                />
                <Divider variant="middle" />
                <CustomListItem
                  path="/driver/notifications"
                  title="اعلان‌ها"
                  icon={
                    <NotifsIcon
                      size={20}
                      color={
                        pathname === "/driver/notifications"
                          ? "#fff"
                          : theme.palette.textColor.main
                      }
                    />
                  }
                />
                <Divider variant="middle" />
                <CustomListItem
                  path="/driver/survey"
                  title="نظرسنجی"
                  icon={
                    <PenSVG
                      size={20}
                      color={
                        pathname === "/driver/survey"
                          ? "#fff"
                          : theme.palette.textColor.main
                      }
                    />
                  }
                />
                {/* <Divider variant="middle" />
                <CustomListItem
                  path="/driver/ticket"
                  title="پشتیبانی"
                  icon={
                    <SupportSVG
                      size={20}
                      color={
                        pathname === "/driver/ticket"
                          ? "#fff"
                          : theme.palette.textColor.main
                      }
                    />
                  }
                /> */}
                <Divider variant="middle" />
                <CustomListItem
                  path="/driver/communicate-companies"
                  title="ارتباط با شرکت‌ها"
                  icon={
                    <BuildingSingleSVG
                      size={20}
                      color={
                        pathname === "/driver/communicate-companies"
                          ? "#fff"
                          : theme.palette.textColor.main
                      }
                    />
                  }
                />
                {/* <Divider variant="middle" /> */}
                {/* <CustomListItem
                  path="#"
                  title="آمار فعالیت"
                  icon={
                    <ReportUpSVG
                      size={20}
                      color={
                        pathname === "/driver/notifications"
                          ? "#fff"
                          : theme.palette.textColor.main
                      }
                    />
                  }
                />
                <Divider variant="middle" /> */}
                {/* <CustomListItem
                  path="#"
                  title="ثبت بار"
                  icon={
                    <RegisterLoadSVG
                      size={20}
                      color={
                        pathname === "/driver/communicate-companies"
                          ? "#fff"
                          : theme.palette.textColor.main
                      }
                    />
                  }
                /> */}
              </List>
            </nav>
          </Box>
          <Box
            sx={{
              backgroundColor:
                themeMode === "dark" ? alpha("#fff", 0.1) : "#fff",
              // border: "1px solid gray",
              borderRadius: "10px",
              width: "100%",
              maxWidth: 360,
            }}
          >
            <nav
              style={{
                padding: "0px 8px",
              }}
              aria-label="main mailbox folders"
            >
              <List
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                }}
              >
                {/* <CustomListItem
                  path="/driver/karenclub/courses"
                  title="آموزش ببین و امتیاز بگیر"
                  icon={
                    <GuidSVG size={20} color={theme.palette.textColor.main} />
                  }
                /> */}
                <CustomListItem
                  path="/guides"
                  title="راهنمای جامع بازارگاه"
                  icon={
                    <GuidSVG size={20} color={theme.palette.textColor.main} />
                  }
                />
                <CustomListItem
                  path="/terms"
                  title="قوانین"
                  icon={
                    <InfoCircle
                      size={20}
                      color={theme.palette.textColor.main}
                    />
                  }
                />
                <Divider variant="middle" />
                <CustomListItem
                  title={isUpdating ? "در حال بروزرسانی..." : "به روز رسانی"}
                  icon={
                    <RefreshSVG
                      size={20}
                      color={theme.palette.textColor.main}
                    />
                  }
                  actionOnly
                  handleClick={handleUpdateApp}
                />
                <Divider variant="middle" />
                <CustomListItem
                  type="exit"
                  handleClick={() => handleLogout()}
                  path="#"
                  title="خروج از حساب کاربری"
                  icon={<LogoutSVG color={theme.palette.error.main} />}
                />
                {/* <CustomListItem path="#" title="ثبت بار" icon={TermsIcon} /> */}
              </List>
            </nav>
          </Box>
        </Box>

        {/* <Box
          sx={{
            backgroundColor: "background.default",
            // border: "1px solid gray",
            borderRadius: "10px",
            padding: "16px",
            width: "100%",
            maxWidth: 360,
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <img width={20} src={CallIcon} alt="" />
            <Typography
              sx={{
                fontWeight: "600",
              }}
            >
              شماره تماس مرکز:
            </Typography>
          </Box>
          <Typography
            sx={{
              fontWeight: "600",
            }}
          >
            07633452480-3
          </Typography>
        </Box> */}
      </SwipeableDrawer>
    </div>
  );
}
